import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';

const AppRoutes: Routes = [
    { path: '', component: AppComponent },
    { path: 'success', component: AppComponent },
    { path: '**', redirectTo:'', pathMatch: 'full'}

];

@NgModule({
    imports: [
        RouterModule.forRoot(AppRoutes, { useHash: true })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
